<template>
  <path
    d="M19 4.00018H15L7.11 16.6302L4.5 12.0002L9 4.00018H5L0.5 12.0002L5 20.0002H9L16.89 7.37018L19.5 12.0002L15 20.0002H19L23.5 12.0002L19 4.00018Z"
  />
</template>
